import { render, staticRenderFns } from "./HeroText.vue?vue&type=template&id=9227a8da&scoped=true&"
import script from "./HeroText.vue?vue&type=script&lang=js&"
export * from "./HeroText.vue?vue&type=script&lang=js&"
import style0 from "./HeroText.vue?vue&type=style&index=0&id=9227a8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9227a8da",
  null
  
)

export default component.exports